/**
 * Layout-route guard for business-only pages. A customer session (Firebase ID
 * token, which carries a `firebase` claim; backend JWTs don't) is sent to the
 * business login instead of mounting the page — mounting would fire the
 * page's data fetches with the wrong token and produce a wall of 403s.
 * The business login page lets the user switch accounts (see
 * AuthorizedRedirect), so there is no redirect loop.
 *
 * Guests and business/admin sessions pass through untouched; the existing
 * per-page <AuthProtected /> keeps handling those.
 *
 * Usage in App.js:
 *   <Route element={<BusinessSessionGuard />}>
 *     <Route path="/dashboard" element={<Dashboard3 />} />
 *     ...
 *   </Route>
 */
import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

export const BusinessSessionGuard = ({ authorized, isCustomerSession }) => {
  if (authorized && isCustomerSession) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};

BusinessSessionGuard.propTypes = {
  authorized: PropTypes.bool,
  isCustomerSession: PropTypes.bool,
};

const mapStateToProps = state => ({
  authorized: state.auth.authorized,
  isCustomerSession: Boolean(
    state.auth.tokens.accessDecoded && state.auth.tokens.accessDecoded.firebase,
  ),
});

export default connect(mapStateToProps)(BusinessSessionGuard);